import { render, staticRenderFns } from "./bindHotline.vue?vue&type=template&id=80dd8ace&scoped=true&"
import script from "./bindHotline.vue?vue&type=script&lang=js&"
export * from "./bindHotline.vue?vue&type=script&lang=js&"
import style0 from "./bindHotline.vue?vue&type=style&index=0&id=80dd8ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dd8ace",
  null
  
)

export default component.exports